import axios from 'axios'
import { getRequestConfig } from 'client/api/index'
import { ExperimentInterface } from 'client/Interfaces/ExperimentsInterface'

export async function getExperiments(): Promise<ExperimentInterface[]> {
  const response = await axios.get('/experiments/experimentation', getRequestConfig())
  return response.data
}
